import styled from "styled-components";
import { theme, styledSystemTheme } from "../theme/lexusTheme";
import Icon from "./Icon";

export const Wrapper = styled.div<{ onlyOneOption?: boolean; isLoading?: boolean }>`
    position: relative;
    padding: 5px 0;
    text-align: start;
    cursor: ${({ onlyOneOption, isLoading }) => (onlyOneOption || isLoading ? "default" : "pointer")};
    svg {
        display: flex;
        flex-shrink: 0;
        @media print {
            display: none;
        }
    }
`;

export const WrapperDarkVariant = styled.div`
    position: relative;
    height: 56px;
    margin-bottom: ${theme.space[3]}px;
    font-family: ${theme.fonts.book};
    font-size: 1.3rem;
    letter-spacing: 0.15rem;
    text-transform: uppercase;
    background: transparent;
    border: 1px solid ${theme.colors.platinumLight};
    border-radius: 0;
`;

export const Toggle = styled.button<{ isOpen: boolean }>`
    display: block;
    position: relative;
    width: 100%;
    padding: ${styledSystemTheme.isRTL ? "18px 18px 15px 30px" : "18px 30px 15px 18px"};
    font-size: 1.3rem;
    text-align: start;
    text-decoration: none;
    color: ${theme.colors.platinumDark};
    background: ${({ isOpen }) => (isOpen ? theme.colors.silver : "none")};
    border-radius: ${({ isOpen }) => (isOpen ? "4px 4px 0 0" : "4px")};
    outline: 0;
    cursor: pointer;

    ${Icon} {
        position: absolute;
        top: 50%;
        right: 10px;
        transform: ${({ isOpen }) => (isOpen ? "rotate(180deg) translateY(-50%)" : "translateY(-50%)")};
        transform-origin: top center;
    }

    &:hover {
        text-decoration: none;
    }

    html[dir="rtl"] & {
        ${Icon} {
            left: 10px;
            right: auto;
        }
    }
`;

export const Items = styled.ul`
    display: block;
    position: absolute;
    top: 100%;
    left: -1px;
    right: -1px;
    min-width: 162px;
    margin: 0;
    padding: 0;
    font-size: 1.3rem;
    list-style: none;
    text-align: left;
    background-color: ${theme.colors.white};
    border: 1px solid ${theme.colors.platinumLight};
    border-top: none;
    border-radius: 0;
    box-shadow: none;
    z-index: 1000;
`;

export const Item = styled.li`
    display: block;
    margin: 0;
    padding: 11px 18px 15px;
    font-size: 1.5rem;
    color: #333;
    background: ${theme.colors.silver};
    border: none;
    box-shadow: inset 0 -1px 0 0 rgba(0, 0, 0, 0.05);
    &:hover {
        background: ${theme.colors.mist};
    }
`;

export const Title = styled.button<{ selected?: boolean; height?: number; showPointer: boolean; isPdf?: boolean }>`
    display: ${({ isPdf }) => (isPdf ? "block" : "flex")};
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
    min-height: ${({ height, isPdf }) => (height && !isPdf ? height : 0)}px;
    padding-bottom: 5px;
    font-family: ${theme.fonts.book};
    font-size: 1.6rem;
    line-height: 2.4rem;
    text-align: start;
    color: ${theme.colors.midnight};
    cursor: ${({ showPointer }) => (showPointer ? "pointer" : "inherit")};
`;
